var _linearGradient, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: 512,
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 48 48",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    gradientTransform: "matrix(39.394 -36.688 36.688 39.394 3.737 110.285)",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0056e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#0056e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e5b8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -53)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.438 -14.883)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ngicon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.82 95.746c-1.992 1.677-3.258 4.189-3.258 6.994 0 5.046 4.097 9.143 9.143 9.143 2.805 0 5.317-1.266 6.995-3.257h16.348c1.993 0 3.904-.792 5.314-2.201 1.409-1.409 2.2-3.32 2.2-5.313v-21.715c0-1.992-.791-3.904-2.2-5.313-1.41-1.409-3.321-2.201-5.314-2.201h-21.714c-1.993 0-3.904.792-5.313 2.201-1.41 1.409-2.201 3.321-2.201 5.313zm5.885-.149c3.943 0 7.143 3.201 7.143 7.143 0 3.943-3.2 7.143-7.143 7.143-3.942 0-7.143-3.2-7.143-7.143 0-3.942 3.201-7.143 7.143-7.143zm-.881 7.615c.075.141.185.266.327.36l3.257 2.172c.459.306 1.08.182 1.387-.278.306-.459.181-1.08-.278-1.386l-2.812-1.875v-4.35c0-.552-.448-1-1-1s-1 .448-1 1v4.885c0 .171.043.332.119.472zm16.91-.529h8.8c.552 0 1-.448 1-1s-.448-1-1-1h-8.8c-.552 0-1 .448-1 1s.448 1 1 1zm0-5.257h8.8c.552 0 1-.448 1-1s-.448-1-1-1h-8.8c-.552 0-1 .448-1 1s.448 1 1 1zm-8.943-23.543h10.8v8.967c0 .23-.122.442-.321.557-.198.115-.443.116-.643.002l-3.94-2.251c-.307-.176-.685-.176-.992 0l-3.94 2.251c-.2.114-.445.113-.643-.002-.199-.115-.321-.327-.321-.557z",
    fill: "url(#_Linear1)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.4a5d981f53e762bdc7ac38b93e3e9253.svg";
export { ForwardRef as ReactComponent };